import React from 'react'

const Footer = ({className}) => {
  return (
    <div className={`confidential ${className}`}>
      CONFIDENTIAL PROPERTY OF MARS INC. DO NOT DISTRIBUTE
    </div>
  )
}

export default Footer
